import cx from 'classnames'
import Styles from './LineSkeleton.module.scss'

export interface LineSkeletonProps {
  className?: string
  width?: string | number
}

export const LineSkeleton = ({ className, width }: LineSkeletonProps) => {
  return <div className={cx(Styles.shimmer, className)} style={{ width }} />
}
